import React, { useEffect, useState } from "react";
import { Box, Button, CircularProgress, Alert } from "@mui/material";
import { useNavigate } from "react-router-dom";
import DynamicTableForJson from "../../../../../data/DynamicTable/dynamicTableForJson";
import { AssetFinanceUrl } from "../../../../../config";
import { fetchJsonDynamic } from "../../../../../data/DynamicServiceNew/jsondynamicservice";
import DirectorForm from "./DirectorForm";

const base_url = AssetFinanceUrl.uri;

const parseResults = (response) => {
  if (!response) return [];
  if (Array.isArray(response)) return response;
  if (Array.isArray(response?.results)) return response.results;
  if (typeof response?.results === "string") {
    try {
      const parsed = JSON.parse(response.results);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }
  return [];
};

const directorColumns = [
  { field: "Id", headerName: "ID", width: 80 },
  { field: "FullName", headerName: "Full Name", flex: 1 },
  { field: "Email", headerName: "Email", flex: 1 },
];

const DirectorsModal = () => {
  const navigate = useNavigate();
  const collateralAssetId = localStorage.getItem("collateralAssetId");
  const ownershiptype = localStorage.getItem("ownershiptype");

  const [loading, setLoading] = useState(false);
  const [companyOwner, setCompanyOwner] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    if (!collateralAssetId) return;
    setCompanyOwner(null);
    setNotFound(false);
    (async () => {
      setLoading(true);
      try {
        const res = await fetchJsonDynamic(
          "collateralCompanyOwnerByColumnValues",
          "companyOwner",
          { collateralAssetId: Number(collateralAssetId) },
          base_url,
        );
        const [owner] = parseResults(res);
        if (owner?.Id) setCompanyOwner(owner);
        else setNotFound(true);
      } catch {
        setNotFound(true);
      } finally {
        setLoading(false);
      }
    })();
  }, [collateralAssetId]);

  if (!collateralAssetId) return null;

  const FormWithCompanyOwner = (formProps) => (
    <DirectorForm {...formProps} companyOwnerId={companyOwner?.Id} />
  );

  const actions = {
    entity: "Approved Customer",
    isSubright: true,
    edit: { key: "EDIT", button_name: "Edit", Show_Button: true, permission: "EditPermission" },
    delete: { key: "DELETE", button_name: "Delete", Show_Button: true, permission: "DeletePermission" },
    add: { key: "ADD", button_name: "Add Director", Show_Button: true, permission: "CreatePermission" },
    dataObject: {
      ignoreFields: ["CreatedBy", "UpdatedBy", "UpdatedAt", "CompanyOwnerId"],
      objectName: "collateralCompanyDirectorByColumnValues",
      parameters: { companyOwnerId: companyOwner ? Number(companyOwner.Id) : null },
      inputObjectName: "director",
    },
  };

  return (
    <Box m="20px">
      <Box display="flex" justifyContent="flex-end" mb={2}>
        <Button onClick={() => navigate(-1)} variant="contained">
          Back to Assets
        </Button>
      </Box>
      {loading ? (
        <Box display="flex" justifyContent="center" py={6}>
          <CircularProgress />
        </Box>
      ) : notFound ? (
        <Alert severity="warning">
          No company owner record found for this asset yet. Open <b>"Edit"</b> on the collateral asset and save the
          company details first — then come back here to add directors.
        </Alert>
      ) : (
        <DynamicTableForJson
          title={`Directors — ${companyOwner?.CompanyName || `Asset #${collateralAssetId}`}`}
          subtitle="Manage this company's registered directors (at least 2 required)"
          FormComponent={FormWithCompanyOwner}
          columns={directorColumns}
          base_url={base_url}
          actions={actions}
        />
      )}
    </Box>
  );
};

export default DirectorsModal;